import theme from '@styles/theme';
export default {
  mainContainer: {
    backgroundColor: theme.rawColors.lightGrey300,
    p: ['40px', '40px', '40px', '40px', '64px 40px']
  },
  containerContent: {
    maxWidth: '1218px',
    margin: 'auto',
    'h1, h2, h3, h4, h5, h6': {
      fontFamily: theme.fonts.uniformExtra,
      fontWeight: theme.fontWeights.normal,
      fontSize: [theme.fontSizes.bigText, theme.fontSizes.bigText, theme.fontSizes.bigText, theme.fontSizes.bigText, theme.fontSizes.h4],
      lineHeight: '100%',
      letterSpacing: theme.letterSpacings.caps,
      textTransform: 'uppercase',
      mb: '16px'
    },
    p: {
      fontSize: theme.fontSizes.smallText,
      mb: '32px'
    },
    'p:last-of-type': {
      mb: 0
    }
  }
};